import StudentCareServices from '@/services/StudentCareServices';

export default {
  data() {
    return {
      TUTOR_PRIMARY_TAGS: [],
      TUTOR_SECONDARY_TAGS: [],
      BLENDED_PRIMARY_TAGS: [],
      BLENDED_SECONDARY_TAGS: [],
    };
  },
  created() {
    this.getTagOption();
  },
  methods: {
    async getTagOption() {
      const result = await StudentCareServices.getTagOption();
      if (result.message === 'Success') {
        result.data.forEach((e) => {
          if (e.module.includes('tutor_primary')) {
            this.TUTOR_PRIMARY_TAGS.push(e);
          }
          if (e.module.includes('tutor_secondary')) {
            this.TUTOR_SECONDARY_TAGS.push(e);
          }
          if (e.module.includes('blended_primary')) {
            this.BLENDED_PRIMARY_TAGS.push(e);
          }
          if (e.module.includes('blended_secondary')) {
            this.BLENDED_SECONDARY_TAGS.push(e);
          }
        });
      }
    },
  },
};
